export default __webpack_public_path__ + "static/media/bg3.62a91114.svg";